import React, { useRef, useEffect, useCallback } from 'react';
import styles from './SpotlightOverlay.module.scss';

interface SpotlightOverlayProps {
  intensity?: number;
  size?: number;
}

const SpotlightOverlay: React.FC<SpotlightOverlayProps> = ({
  intensity = 0.25,
  size = 1200,
}) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const animationFrameRef = useRef<number>();

  const updateSpotlight = useCallback((x: number, y: number) => {
    if (!overlayRef.current) return;
    
    overlayRef.current.style.setProperty('--mouse-x', `${x}px`);
    overlayRef.current.style.setProperty('--mouse-y', `${y}px`);
    overlayRef.current.style.setProperty('--spotlight-intensity', intensity.toString());
    overlayRef.current.style.setProperty('--spotlight-size', `${size}px`);
  }, [intensity, size]);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      // Cancel previous animation frame
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }

      // Schedule update for next frame
      animationFrameRef.current = requestAnimationFrame(() => {
        updateSpotlight(e.clientX, e.clientY);
      });
    };

    // Add event listener with passive flag for better performance
    document.addEventListener('mousemove', handleMouseMove, { passive: true });

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [updateSpotlight]);

  return (
    <div
      ref={overlayRef}
      className={styles.spotlightOverlay}
    />
  );
};

export default SpotlightOverlay; 